<script>
import { computed } from 'vue'
import { usePage } from '@inertiajs/inertia-vue3'
import { defineComponent, h, PropType, getCurrentInstance } from 'vue'
import format from 'date-fns/format';
import ptBR from 'date-fns/locale/pt-BR';
import { Bar } from 'vue-chartjs'
import {
    Chart as ChartJS,
    Title,
    Tooltip,
    Legend,
    BarElement,
    LinearScale,
    PointElement,
    CategoryScale,
    Plugin
} from 'chart.js'

ChartJS.register(
    Title,
    Tooltip,
    Legend,
    BarElement,
    LinearScale,
    PointElement,
    CategoryScale
);

export default {
    components: {
        Bar,
    },
    props: {
        chartId: {
            type: String,
            default: 'bar-chart'
        },
        width: {
            type: Number,
            default: 400
        },
        height: {
            type: Number,
            default: 400
        },
        cssClasses: {
            default: '',
            type: String
        },
        styles: {
            type: Object,
            default: () => { }
        },
        plugins: {
            type: Array,
            default: () => []
        },
        chartData: {
            type: Object,
            default: () => { }
        },
    },
    data() {
        return {

        }
    },
    methods: {

    },
    setup(props) {
        const app = getCurrentInstance();
        const capitalize = app.appContext.config.globalProperties.$filters.capitalize;
        const user = computed(() => usePage().props.value.auth.user);

        const chartData = props.chartData;

        const chartOptions = {
            animation: false,
            responsive: true,
            maintainAspectRatio: false,
            scales: {
                x: {
                    stacked: true,
                    ticks: {
                        callback: function(value, index, ticks) {
                            return capitalize(format(new Date(chartData.labels[index] + '-01 00:00:00'), 'MMM/yy', {locale: ptBR}));
                        }
                    }
                },
                y: {
                    stacked: true,
                    min: 0,
                    max: undefined,
                    ticks: {
                        callback: function(value, index, ticks) {
                            return 'R$ ' + value.toLocaleString('pt-BR', {minimumFractionDigits: 2});
                        }
                    }
                }
            },
            interaction: {
                intersect: false,
                mode: 'index',
            },
            plugins: {
                tooltip: {
                    filter: (e, index, array, data) => {
                        return e.raw > 0;
                    },
                    callbacks: {
                        title: (tooltipItems) => {
                            if(!tooltipItems.length) return false;
                            return capitalize(format(new Date(tooltipItems[0].label + '-01 00:00:00'), 'MMMM/yyyy', {locale: ptBR}));
                        },
                        afterBody: (tooltipItems) => {
                            let total = tooltipItems.reduce((a, e) => a + e.raw, 0);
                            if(!total) return false;
                            return 'Total: R$ ' + total.toLocaleString('pt-BR', {minimumFractionDigits: 2});
                        },
                        label: (tooltipItem) => {
                            if(!tooltipItem.raw) return false;
                            return tooltipItem.dataset.label + ' R$ ' + tooltipItem.raw.toLocaleString('pt-BR', {minimumFractionDigits: 2});
                        }
                    }
                },
            },
        }

        return () =>
            h(Bar, {
                chartData,
                chartOptions,
                chartId: props.chartId,
                width: props.width,
                height: props.height,
                cssClasses: props.cssClasses,
                styles: props.styles,
                plugins: props.plugins
            })
    },
    mounted() {
    },
}
</script>